import Dexie from "dexie";
import router from "@/router";
import { useStore } from "vuex";

/**
 *
 * @returns {Dexie}
 */
export function getLocalDataBase() {
  if (router.currentRoute.value.params.tenant && router.currentRoute.value.params.store) {
    const { tenant, store } = router.currentRoute.value.params;
    const databasename = `EAPOS_${tenant}_${store}`;

    // Declare db instance
    const db = new Dexie(databasename);
    // Define Database Schema
    db.version(14).stores({
      entities: "entity",
      // families:
      //   "id, familyLevel, parentId, status, subFamilies, synccounter, data",
      families: "id, code, [familyLevel+status], [parentCode+status], subFamilies, synccounter, data",
      salesmen: "id, name, status, synccounter, sessionStatus, sessionDate, data",
      paymentMethods: "id, status, synccounter, data",
      // items: "id, code, barcode, description, family, status, synccounter, data",
      items: "id, status, code, barcode, mainDescription, description, [family+status], synccounter, data",
      cashDrawers: "id, tillId, description, isOpen, [isOpen+status], status, default, synccounter, data",
      itemsSearchTerms: "id, status, mainDescription, description, code, *barcode, parentItem",
      countries: "id, status, name, ISOCountryId, synccounter, data",
      // salesPricesRanges: "code, description, status",
      //@modified ana.castro 2022.12.05 SAFO-47
      zones: "code, description, status, salesPriceRange, data",
      permissionsGroup: "id, description, status, synccounter, activePermissions",
      extensionFields: "id, code, model, name, required, type, data",
      //@modified ana.castro 2023.08.08 SAFO-75
      //actionType: apiPost, apiFetch, Vue.axios, loadingLayer
      //data: a dictionary with details
      posDataLog: "++id, date, actionType, value, data",
      docTypes: "id, code, nature, description, synccounter, printPageSize, data",
    });

    return db;
  } else {
    console.warn("Tenant or Store is not available in current route parameters.");
  }
}

export function updateDatabase(force) {
  const store = useStore();
  let autoSync = 1;
  let forceUpdate = force ?? 0;

  if (router.currentRoute.value.params.tenant && router.currentRoute.value.params.store) {
    store.dispatch("tenants/setConfiguration", {
      forceUpdate,
      autoSync,
    });
  }
}
